module.exports = __webpack_public_path__ + "img/icon-arrow.0854667a.png";